.CheckoutContainer
    position: fixed
    left: 0
    top: 0
    right: 0
    bottom: 0
    display: flex
    flex-direction: column
    margin: 0
    padding: 0
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    background-color: rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
    z-index: $indexCheckout
    overflow: hidden
    animation: 0.2s ease-in-out 0s 1 normal none running openCheckout

@keyframes openCheckout
    0%
        opacity: 0
    100%
        opacity: 1

.ButtonContainer
    stroke: rgb($globalSettingsFontSecondary)
    cursor: pointer
    &:hover
        stroke: rgb($globalSettingsFontTertiary)

.ContentContainer
    width: 100%
    display: flex
    flex-direction: column
    flex: 1
    margin: 0
    padding: 0
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    background-color: rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
    overflow: hidden
    position: relative

@media #{$tablet}
    .CheckoutContainer
        height: calc(100% - 20px)
        max-height: calc(100% - 20px)
        width: 720px
        right: unset
        bottom: unset
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        border-radius: $globalSettingsRoundingLarge
    .ContentContainer
        border-radius: 0 0 $globalSettingsRoundingLarge $globalSettingsRoundingLarge
@media #{$tablet} and (min-height: 740px)
    .CheckoutContainer
        height: 720px

//modal
.CheckoutTemplateModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontPrimary)
    cursor: pointer
    z-index: $indexCheckout - 1
    animation: 0.3s ease-in-out 0s 1 normal none running openModal
    opacity: 0.6

@keyframes openModal
    0%
        opacity: 0
    100%
        opacity: 0.6
